import React from "react";
import { QueryClient } from "@tanstack/react-query";
import { createTRPCUntypedClient } from "@trpc/client";
import { createTrpcLinks, trpc } from "./client";
import type { AppRouter } from "../../../.generated-trpc-types/apps/backend/src/app.router";

interface TRPCProviderProps {
  children: React.ReactNode;
  queryClient: QueryClient;
}

export function TRPCProvider({ children, queryClient }: TRPCProviderProps) {
  // Note: Using httpLink instead of httpBatchLink to avoid batching issues with Railway's proxy
  const trpcClient = React.useMemo(
    () =>
      createTRPCUntypedClient<AppRouter>({
        links: createTrpcLinks(),
      }),
    [],
  );

  return (
    <trpc.Provider client={trpcClient} queryClient={queryClient}>
      {children}
    </trpc.Provider>
  );
}
